<template>
  <div class="ms-form ms-form--narrow">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-form v-else @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <div class="entrance-info">
          <div class="entrance-info__project">{{ data.body.project_short_name }}</div>
          <div class="entrance-info__entrance">
            Подъезд №{{ data.body.entrance }}
          </div>
        </div>
        <CustomSelect
          :options="this.residentsOptions"
          :label="`Проект для ${data?.isTransfer ? 'разделения проекта' : 'дублирования подъезда'} `"
          optionValueKey="project_id"
          optionLabelKey="project_short_name"
          :value="this.formData.project_id || ''"
          @change="(value) => onChange('project_id', value)"
          :required="true"
          :clearable="false"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getProjectsById  } from "@/views/ShellProjects/services";

export default {
  name: "copy-paste-entrance-properties",
  components: { CustomInput, CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      residentsOptions: [],
      formData: {
        project_id: ''
      },
    };
  },
  async mounted() {
    this.isFetching = true;
    await this.getProjectsOptions(this.data?.body?.project_id);

    this.isFetching = false;
  },
  methods: {
    async getProjectsOptions(project_id) {
      const res = await getProjectsById(project_id);
      this.residentsOptions = res || [];
    },

    async onChange(key, value) {
      this.formData[key] = value;
      return;
    },
    async onSubmit() {
      this.loading = true;
      try {
        await this.data?.onSubmit(this.formData);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.entrance-info {
  font-size: 13px;
  line-height: 20px;

  &__project {
    font-weight: 600;
    color: var(--ms-text);
  }

  &__entrance {
    color: var(--ms-text-secondary);
  }
}
</style>
